/**
 * OD: Show gallery slides whose image alt text contains the current variant title
 * (normalized; gray/grey aliased). Dispatches odx-variant-media-filter-result for ODMIN timeline.
 */
(function () {
  function emitFilterResult(detail) {
    try {
      document.dispatchEvent(
        new CustomEvent('odx-variant-media-filter-result', {
          bubbles: true,
          detail: detail,
        }),
      );
    } catch (e) {}
  }

  function applyVariantMediaFilter() {
    const picker = document.querySelector("variant-selects");
    if (!picker) {
      emitFilterResult({ phase: "skip", reason: "no variant-selects" });
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const activeId =
      urlParams.get("variant") || picker.querySelector("input:checked")?.value;

    if (!activeId) {
      emitFilterResult({ phase: "skip", reason: "no active variant id" });
      return;
    }

    const variantDataElement = picker.querySelector(
      'script[type="application/json"]',
    );
    if (!variantDataElement) {
      emitFilterResult({ phase: "skip", reason: "no variant json" });
      return;
    }

    let variantData;
    try {
      variantData = JSON.parse(variantDataElement.textContent);
    } catch (e) {
      emitFilterResult({ phase: "skip", reason: "variant json parse error" });
      return;
    }

    const currentVariant = variantData.find((v) => v.id == activeId);
    if (!currentVariant) {
      emitFilterResult({ phase: "skip", reason: "variant not in json", activeId: activeId });
      return;
    }

    const normalize = (str) =>
      String(str || "")
        .toLowerCase()
        .replace(/gray/g, "grey")
        .trim();
    const variantTitle = normalize(currentVariant.title);

    const galleries = document.querySelectorAll("media-gallery");
    const gallery = galleries[0];
    if (!gallery) {
      emitFilterResult({
        phase: "skip",
        reason: "no media-gallery",
        galleryCount: 0,
        variantId: currentVariant.id,
        variantTitle: currentVariant.title,
      });
      return;
    }

    const items = gallery.querySelectorAll(".product__media-item");
    let matchCount = 0;
    let hiddenSample = [];
    items.forEach((item) => {
      const img = item.querySelector("img");
      const altText = normalize(img?.alt || img?.getAttribute("alt") || "");

      const isMatch = variantTitle !== "" && altText.includes(variantTitle);

      if (isMatch) {
        item.classList.remove("hide-media");
        item.classList.add("is-active");
        matchCount += 1;
      } else {
        item.classList.add("hide-media");
        item.classList.remove("is-active");
        if (hiddenSample.length < 3) {
          hiddenSample.push(
            (altText || "").slice(0, 80) || "(empty alt)",
          );
        }
      }
    });

    let usedFallback = false;
    if (matchCount === 0 && items.length > 0) {
      usedFallback = true;
      items.forEach((item, index) => {
        item.classList.remove("hide-media");
        item.classList.toggle("is-active", index === 0);
      });
    }

    emitFilterResult({
      phase: "applied",
      variantId: currentVariant.id,
      variantTitle: currentVariant.title,
      normalizedFilter: variantTitle,
      galleryCount: galleries.length,
      itemCount: items.length,
      matchCount: usedFallback ? items.length : matchCount,
      usedFallback: usedFallback,
      altSamplesHidden: hiddenSample,
    });

    const slider = gallery.querySelector("slider-component");
    if (slider && typeof slider.init === "function") {
      slider.init();
    }

    const strip = gallery.querySelector('[id^="Slider-Gallery-"]');
    if (
      strip &&
      strip.id &&
      window.__odxGalleryStripLazyPriorityRefresh &&
      typeof window.__odxGalleryStripLazyPriorityRefresh[strip.id] === "function"
    ) {
      try {
        const run = function () {
          window.__odxGalleryStripLazyPriorityRefresh[strip.id]();
        };
        if (typeof window.requestIdleCallback === "function") {
          window.requestIdleCallback(run, { timeout: 900 });
        } else {
          setTimeout(run, 0);
        }
      } catch (_e) {}
    }
  }

  if (document.readyState === "complete") {
    setTimeout(applyVariantMediaFilter, 100);
  } else {
    window.addEventListener("load", applyVariantMediaFilter);
  }

  const pickerElement = document.querySelector("variant-selects");
  if (pickerElement) {
    pickerElement.addEventListener("change", () => {
      setTimeout(applyVariantMediaFilter, 150);
    });
  }

  document.addEventListener("shopify:section:load", applyVariantMediaFilter);
})();
